import React from "react";
import {
  Button,
  FormFieldSet,
  Modal,
  showToast,
} from "../../../../../../../components";

const ScheduleModal = ({ isOpen, onClose }) => {
  return (
    <div>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        title={"Schedule Campaign"}
        titleColor={"primary"}
        width="max-w-2xl"
      >
        <div className="grid grid-cols-2 mx-3 gap-4">
          <FormFieldSet
            type="datepicker"
            showTime
            title="Select Date and Time to Schedule"
            placeholder="Select Date and Time"
          />
        </div>
        <div className="flex justify-end gap-3 my-10">
          <Button
            title={"Cancel"}
            variant="outlined"
            size="sm"
            onClick={onClose}
          />
          <Button
            title={"Save"}
            size="sm"
            onClick={() => {
              onClose();
              showToast("Campaign Scheduled", "success");
            }}
          />
        </div>
      </Modal>
    </div>
  );
};

export default ScheduleModal;
